import React, { useEffect, useState } from "react";

const MenuStacker = ({ selected, setSelected, selectedValueOne, selectedValueTwo }) => {
    useEffect(() => {
        setSelected(selectedValueOne.data);
    }, []);

    return (
        <div className="menu-stacker">
                <>
                    <li className={ selected === selectedValueOne.data ? "menu-item-stacker-selected" : "menu-item-stacker" } onClick={() => setSelected(selectedValueOne.data)}>{selectedValueOne.copy}</li>
                    <li className={ selected === selectedValueTwo.data ? "menu-item-stacker-selected" : "menu-item-stacker" } onClick={() => setSelected(selectedValueTwo.data)}>{selectedValueTwo.copy}</li>

                </>
           
        </div>
    );
}

export default MenuStacker;